module.exports = __webpack_public_path__ + "static/media/SHI.ea48d0df.png";